"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _icons = require("../icons");

var _InputActionButton = _interopRequireDefault(require("./InputActionButton"));

var _core = require("@emotion/core");

var _excluded = ["altText"];

var InputClearButton = function InputClearButton(_ref) {
  var _ref$altText = _ref.altText,
      altText = _ref$altText === void 0 ? 'Clear input' : _ref$altText,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return (0, _core.jsx)(_InputActionButton.default, (0, _extends2.default)({
    icon: _icons.IconCross,
    altText: altText
  }, rest));
};

InputClearButton.displayName = 'InputClearButton';
var _default = InputClearButton;
exports.default = _default;